import React from "react";
import GitHubCalendar from "react-github-calendar";
import { Row } from "react-bootstrap";

function Github() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
      <h1 className="project-heading" style={{ paddingBottom: "20px" }}>
        <strong>Code Chart</strong>
      </h1>
      <GitHubCalendar
        username="Alpattex"
        blockSize={15}
        blockMargin={5}
        color="#80c877"
        fontSize={16}
      />
    </Row>
  );
}

export default Github;
